import React, { useEffect, useState } from 'react';
import HeroScreen from '../../../Views/HeroScreen';
import AnimeCard from './AnimeCard';
import SEOHead from '../../SEO/SEOHead';
import './AnimeStyle.css';

const TopAnime = () => {
    const [animeList, setAnimeList] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchTopAnime = async () => {
            try {
                const res1 = await fetch('https://api.jikan.moe/v4/top/anime?page=1&limit=25');
                const data1 = await res1.json();
                const page1 = data1.data || [];
                setAnimeList(page1);
                setLoading(false);

                await new Promise(r => setTimeout(r, 400));
                const res2 = await fetch('https://api.jikan.moe/v4/top/anime?page=2&limit=25');
                const data2 = await res2.json();
                setAnimeList([...page1, ...(data2.data || [])]);

                await new Promise(r => setTimeout(r, 400));
                const res3 = await fetch('https://api.jikan.moe/v4/top/anime?page=3&limit=25');
                const data3 = await res3.json();
                setAnimeList(prev => [...prev, ...(data3.data || [])]);
            } catch (error) {
                console.error('Error fetching top anime:', error.message);
            } finally {
                setLoading(false);
            }
        };
        fetchTopAnime();
    }, []);

    return (
        <div className="anime-page-top-anime">
            <SEOHead title="ChibiDash | Top Rated Anime" description="Browse the highest rated anime of all time. Find top-scored anime series and movies on ChibiDash Anime Hub." path="/animehub/top-anime" />
            <HeroScreen apiUrl="https://api.jikan.moe/v4/top/anime" />
            <h2 className="small-cards-title">Top Rated Anime</h2>
            <p className="results-count">{animeList.length} anime found</p>
            {loading ? (
                <div className="loading-spinner-container">
                    <div className="loading-spinner"></div>
                    <p className="loading-text">Loading Top Anime...</p>
                </div>
            ) : animeList.length > 0 ? (
                <div className="small-anime-grid">
                    {animeList.map((anime) => (
                        <AnimeCard key={anime.mal_id} anime={anime} />
                    ))}
                </div>
            ) : (
                <p className="empty-text">No anime found.</p>
            )}
        </div>
    );
};

export default TopAnime;
